import { gql } from '@apollo/client';
import { SPOT_ALERT_INFO, USER_LOCATION_INFO, USER_LONG_INFO } from './user-fragments';

export const SET_LOCATION_MUTATION = gql`
    mutation updateUser($id: ID!, $latitude: Float, $longitude: Float, $state: String, $city: String, $zipCode: String, $country: String) {
        updateUser(id: $id, latitude: $latitude, longitude: $longitude, state: $state, city: $city, zipCode: $zipCode, country: $country) {
            id
            ...UserLocationInfo
        }
    }
    ${USER_LOCATION_INFO}
`;

export const GET_INVITE_URL = gql`
    mutation getInviteUrl($inviteType: InvitedAs) {
        getInviteUrl(inviteType: $inviteType)
    }
`;

export const USER_INVITE_DATE_MUTATION = gql`
    mutation updateUser($id: ID!, $showInviteAt: ISO8601DateTime) {
        updateUser(id: $id, showInviteAt: $showInviteAt) {
            showInviteAt
        }
    }
`;

export const UPDATE_SPOT_ALERT_MUTATION = gql`
    mutation updateSpotAlert(
        $radius: Int
        $enclosureType: AlertEnclosure
        $minimumSize: Float
        $dogsAllowed: Boolean
        $active: Boolean
        $latitude: Float
        $longitude: Float
    ) {
        updateSpotAlert(
            latitude: $latitude
            longitude: $longitude
            radius: $radius
            enclosureType: $enclosureType
            minimumSize: $minimumSize
            dogsAllowed: $dogsAllowed
            active: $active
        ) {
            ...SpotAlertInfo
        }
    }
    ${SPOT_ALERT_INFO}
`;

export const UPDATE_USER_MUTATION = gql`
    mutation updateUser(
        $id: ID!
        $bookingReminders: Boolean
        $firstname: String
        $lastname: String
        $phoneNumber: String
        $about: String
        $aboutHost: String
        $aboutHostMore: String
        $email: String
        $firstHear: String
        $firstHearSocialMedia: String
        $referralCode: String
        $tosAgree: Boolean
        $vaccinated: Boolean
        $hostWelcomeMessageBanner: Boolean
        $hostWelcomeMessageText: String
        $hostWelcomeMessagesOn: Boolean
        $hostThankYouMessageText: String
        $hostThankYouMessagesOn: Boolean
        $hostMode: Boolean
        $avatarAws: Upload
        $gender: String
        $birthAt: ISO8601Date
        $race: String
        $instagramUsername: String
        $payoutAccountId: String
        $hostRulesAccepted: Boolean
        $playmatesRules: Boolean
        $rulesAccepted: Boolean
        $showGuestBannerApp: Boolean
        $showGuestBannerFacebook: Boolean
        $showGuestBannerPhoneNumber: Boolean
        $showHostBannerBookingsAutoConfirmed: Boolean
        $showHostBannerDownloadApp: Boolean
        $showHostBannerFacebook: Boolean
        $showHostBannerMembership: Boolean
        $showHostBannerOptimizeSpotSettings: Boolean
        $showHostBannerRisingSpot: Boolean
        $showHostBannerSetupCalendar: Boolean
        $showHostBannerTopSpot: Boolean
        $showHostBannerWelcomeMessage: Boolean
        $showHostBannerMarketing: Boolean
        $testGroups: [String!]
    ) {
        updateUser(
            id: $id
            bookingReminders: $bookingReminders
            firstname: $firstname
            lastname: $lastname
            email: $email
            phoneNumber: $phoneNumber
            about: $about
            aboutHost: $aboutHost
            aboutHostMore: $aboutHostMore
            firstHear: $firstHear
            firstHearSocialMedia: $firstHearSocialMedia
            avatarAws: $avatarAws
            tosAgree: $tosAgree
            vaccinated: $vaccinated
            hostWelcomeMessageBanner: $hostWelcomeMessageBanner
            hostWelcomeMessageText: $hostWelcomeMessageText
            hostWelcomeMessagesOn: $hostWelcomeMessagesOn
            hostThankYouMessageText: $hostThankYouMessageText
            hostThankYouMessagesOn: $hostThankYouMessagesOn
            referralCode: $referralCode
            hostMode: $hostMode
            gender: $gender
            birthAt: $birthAt
            race: $race
            instagramUsername: $instagramUsername
            payoutAccountId: $payoutAccountId
            playmatesRules: $playmatesRules
            hostRulesAccepted: $hostRulesAccepted
            rulesAccepted: $rulesAccepted
            showGuestBannerApp: $showGuestBannerApp
            showGuestBannerFacebook: $showGuestBannerFacebook
            showGuestBannerPhoneNumber: $showGuestBannerPhoneNumber
            showHostBannerBookingsAutoConfirmed: $showHostBannerBookingsAutoConfirmed
            showHostBannerDownloadApp: $showHostBannerDownloadApp
            showHostBannerFacebook: $showHostBannerFacebook
            showHostBannerMembership: $showHostBannerMembership
            showHostBannerOptimizeSpotSettings: $showHostBannerOptimizeSpotSettings
            showHostBannerRisingSpot: $showHostBannerRisingSpot
            showHostBannerSetupCalendar: $showHostBannerSetupCalendar
            showHostBannerTopSpot: $showHostBannerTopSpot
            showHostBannerWelcomeMessage: $showHostBannerWelcomeMessage
            showHostBannerMarketing: $showHostBannerMarketing
            testGroups: $testGroups
        ) {
            ...UserLongInfo
        }
    }
    ${USER_LONG_INFO}
`;

export const UPDATE_USER_SIMPLE_MUTATION = gql`
    mutation updateUser(
        $id: ID!
        $bookingReminders: Boolean
        $firstname: String
        $lastname: String
        $phoneNumber: String
        $about: String
        $aboutHost: String
        $aboutHostMore: String
        $email: String
        $firstHear: String
        $firstHearSocialMedia: String
        $referralCode: String
        $tosAgree: Boolean
        $vaccinated: Boolean
        $hostWelcomeMessageBanner: Boolean
        $hostWelcomeMessageText: String
        $hostWelcomeMessagesOn: Boolean
        $hostThankYouMessageText: String
        $hostThankYouMessagesOn: Boolean
        $hostMode: Boolean
        $avatarAws: Upload
        $gender: String
        $birthAt: ISO8601Date
        $race: String
        $instagramUsername: String
        $payoutAccountId: String
        $hostRulesAccepted: Boolean
        $rulesAccepted: Boolean
        $showGuestBannerApp: Boolean
        $showGuestBannerFacebook: Boolean
        $showGuestBannerPhoneNumber: Boolean
        $showHostBannerBookingsAutoConfirmed: Boolean
        $showHostBannerDownloadApp: Boolean
        $showHostBannerFacebook: Boolean
        $showHostBannerMembership: Boolean
        $showHostBannerOptimizeSpotSettings: Boolean
        $showHostBannerRisingSpot: Boolean
        $showHostBannerSetupCalendar: Boolean
        $showHostBannerTopSpot: Boolean
        $showHostBannerWelcomeMessage: Boolean
        $showHostBannerMarketing: Boolean
        $testGroups: [String!]
    ) {
        updateUser(
            id: $id
            bookingReminders: $bookingReminders
            firstname: $firstname
            lastname: $lastname
            email: $email
            phoneNumber: $phoneNumber
            about: $about
            aboutHost: $aboutHost
            aboutHostMore: $aboutHostMore
            firstHear: $firstHear
            firstHearSocialMedia: $firstHearSocialMedia
            avatarAws: $avatarAws
            tosAgree: $tosAgree
            vaccinated: $vaccinated
            hostWelcomeMessageBanner: $hostWelcomeMessageBanner
            hostWelcomeMessageText: $hostWelcomeMessageText
            hostWelcomeMessagesOn: $hostWelcomeMessagesOn
            hostThankYouMessageText: $hostThankYouMessageText
            hostThankYouMessagesOn: $hostThankYouMessagesOn
            referralCode: $referralCode
            hostMode: $hostMode
            gender: $gender
            birthAt: $birthAt
            race: $race
            instagramUsername: $instagramUsername
            payoutAccountId: $payoutAccountId
            hostRulesAccepted: $hostRulesAccepted
            rulesAccepted: $rulesAccepted
            showGuestBannerApp: $showGuestBannerApp
            showGuestBannerFacebook: $showGuestBannerFacebook
            showGuestBannerPhoneNumber: $showGuestBannerPhoneNumber
            showHostBannerBookingsAutoConfirmed: $showHostBannerBookingsAutoConfirmed
            showHostBannerDownloadApp: $showHostBannerDownloadApp
            showHostBannerFacebook: $showHostBannerFacebook
            showHostBannerMembership: $showHostBannerMembership
            showHostBannerOptimizeSpotSettings: $showHostBannerOptimizeSpotSettings
            showHostBannerRisingSpot: $showHostBannerRisingSpot
            showHostBannerSetupCalendar: $showHostBannerSetupCalendar
            showHostBannerTopSpot: $showHostBannerTopSpot
            showHostBannerWelcomeMessage: $showHostBannerWelcomeMessage
            showHostBannerMarketing: $showHostBannerMarketing
            testGroups: $testGroups
        ) {
            id
        }
    }
`;

export const REQUEST_SENSITIVE_ACTION_MUTATION = gql`
    mutation requestSensitiveAction($actionType: SensitiveAction!) {
        requestSensitiveAction(actionType: $actionType)
    }
`;

export const REQ_MEMBERSHIP_MUTATION = gql`
    mutation requestMembership($spotId: ID!) {
        requestMembership(spotId: $spotId)
    }
`;

export const VIEW_SEARCHPAGE_FILTERS_MUTATION = gql`
    mutation viewSearchPageFilters($testGroup: Boolean!) {
        viewSearchPageFilters(testGroup: $testGroup)
    }
`;

export const VIEW_SEO_FRIENDLY_SIGNUP_MUTATION = gql`
    mutation viewSeoFriendlySignUp($testGroup: Boolean!) {
        viewSeoFriendlySignUp(testGroup: $testGroup)
    }
`;

export const VIEW_NON_AUTH_REVIEW_V2 = gql`
    mutation viewNonAuthReviewV2($testGroup: Boolean!, $sessionUuid: String, $guestSecret: String) {
        viewNonAuthReviewV2(testGroup: $testGroup, sessionUuid: $sessionUuid, guestSecret: $guestSecret)
    }
`;

export const VIEW_FRONT_ONE_PAGE_BOOKING = gql`
    mutation viewFrontOnePageBooking($testGroup: Boolean!, $sessionUuid: String) {
        viewFrontOnePageBooking(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FRONT_RECENT_REVIEWS = gql`
    mutation viewFrontRecentReviews($testGroup: Boolean!, $sessionUuid: String) {
        viewRecentReviews(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_FIRST_HEAR_HOST = gql`
    mutation viewFirstHearHost($testGroup: Boolean!, $sessionUuid: String) {
        viewFirstHearHost(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_REVISE_HOME = gql`
    mutation viewReviseHomepage($testGroup: Boolean!, $sessionUuid: String) {
        viewReviseHomepage(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_ADD_SPOT_REQ_PHOTO = gql`
    mutation viewAddSpotReqPhotoV7480($testGroup: Boolean!, $sessionUuid: String) {
        viewAddSpotReqPhotoV7480(testGroup: $testGroup, sessionUuid: $sessionUuid)
    }
`;

export const VIEW_NASCENT_STATE_CROSS = gql`
    mutation viewNascentStateCross($spotId: ID!) {
        viewNascentStateCross(spotId: $spotId)
    }
`;

export const SIGNUP_HOST = gql`
    mutation signUp(
        $email: String!
        $firstname: String!
        $lastname: String!
        $password: String!
        $phoneNumber: String
        $uuid: String
        $invitedAs: InvitedAs
        $invitedByUuid: String
        $utmSource: String
        $utmMedium: String
        $utmCampaign: String
        $createdFrom: CreatedFrom
        $createdPlatform: CreatedPlatform
    ) {
        signUp(
            email: $email
            firstname: $firstname
            lastname: $lastname
            password: $password
            phoneNumber: $phoneNumber
            uuid: $uuid
            invitedAs: $invitedAs
            invitedByUuid: $invitedByUuid
            utmSource: $utmSource
            utmMedium: $utmMedium
            utmCampaign: $utmCampaign
            createdFrom: $createdFrom
            createdPlatform: $createdPlatform
        ) {
            id
            email
            phoneNumber
            testGroups
        }
    }
`;

export const SIGNUP_V2 = gql`
    mutation signUpV2(
        $email: String!
        $firstname: String
        $lastname: String
        $password: String
        $phoneNumber: String
        $uuid: String
        $invitedAs: InvitedAs
        $invitedByUuid: String
        $utmSource: String
        $utmMedium: String
        $utmCampaign: String
        $createdFrom: CreatedFrom
        $createdPlatform: CreatedPlatform
    ) {
        signUpV2(
            email: $email
            firstname: $firstname
            lastname: $lastname
            password: $password
            phoneNumber: $phoneNumber
            uuid: $uuid
            invitedAs: $invitedAs
            invitedByUuid: $invitedByUuid
            utmSource: $utmSource
            utmMedium: $utmMedium
            utmCampaign: $utmCampaign
            createdFrom: $createdFrom
            createdPlatform: $createdPlatform
        ) {
            id
            email
            phoneNumber
            testGroups
        }
    }
`;

export const USER_ONBOARD = gql`
    mutation onboard($firstname: String!, $lastname: String!, $password: String) {
        onboard(firstname: $firstname, lastname: $lastname, password: $password) {
            id
            status
        }
    }
`;

export const REMOVE_GOOGLE_CALENDAR = gql`
    mutation removeGoogleCalendar {
        removeGoogleCalendar
    }
`;
